import { flagFactory } from '../icon';
import Svg from './pt.svg';

export default flagFactory(Svg);
